import { useEffect, useState } from 'react';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const HideAfterCounterWrapper = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
`;

interface HideAfterCounterProps {
  startFrom: number;
  onComplete: () => void;
}

const HideAfterCounter = ({ startFrom, onComplete }: HideAfterCounterProps) => {
  const [seconds, setSeconds] = useState(startFrom);

  const { t } = useTranslation();

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (seconds) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      if (interval) clearInterval(interval);
      onComplete();
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [seconds, onComplete]);

  return (
    <HideAfterCounterWrapper>
      {`(${t('generic.seconds', { count: seconds })})`}
    </HideAfterCounterWrapper>
  );
};

export default HideAfterCounter;
export type { HideAfterCounterProps };
